import {Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from "@angular/forms";
import { THEMES, ThemeSpec } from "../../types/akit-testbench-types"

declare let AlgebraKIT: any;

interface I18NItem {
    nl: string;
    en: string
}

@Component({
    templateUrl: "./formula-editor.container.html",
    styleUrls: ["./formula-editor.container.less"],
    selector: "app-formula-editor",
    standalone: false
})
export class FormulaEditorContainer implements OnInit {

    public themes = THEMES;
    lang: string = 'en';
    palette: string = 'equations';
    _i18n: string = "['"+this.lang+"']"
    latex:string;
    latexHtml: string;
    content: string;   //content from matharea
    contentHTML: string;
    public theme: ThemeSpec = THEMES[0];
    
    texts: {[id:string]:I18NItem} = {
        TitleFormulaEditor: {
            nl: 'Formule-editor',
            en: 'Formula editor'
        },
        TextFormulaEditor: {
            nl: 'Maak een formule en druk op enter.',
            en: 'Create a formula and press enter.'
        },
        TitleMathArea: {
            nl: 'Tekst- en wiskunde-editor',
            en: 'Text & math editor'
        },
        TextMathArea: {
            nl: 'Typ een tekst. Gebruik de formule editor om wiskunde in te voegen.',
            en: 'Type a text that includes mathematics.'
        },
        Output: {
            nl: 'Resultaat',
            en: 'Output'
        }
    }
    @ViewChild("contentDiv") contentElement: ElementRef;

    public inputForm: UntypedFormGroup;

    constructor(
        private formBuilder: UntypedFormBuilder,
    ) {}

    async ngOnInit() {
        this.inputForm = this.formBuilder.group({
            inputData: this.formBuilder.group({
                palette: new UntypedFormControl(this.palette),
                lang: new UntypedFormControl(this.lang),
                theme: new UntypedFormControl(this.theme.id) 
            })
        });

        this.inputForm.get('inputData.palette').valueChanges.subscribe(_value => this.setPalette(_value));        
        this.inputForm.get('inputData.lang').valueChanges.subscribe(_value => this.setLanguage(_value));        
        this.inputForm.get('inputData.theme').valueChanges.subscribe(_theme => {
            this.theme = THEMES.find(_t => _t.id == _theme)
            if(!this.theme) this.theme = THEMES[0];
            AlgebraKIT._api.changeTheme(this.theme.id);
            // force reloading widgets
            let palette = this.palette;
            this.palette = null;
            setTimeout(() => this.palette = palette);
        });

    }

    getText(id: string) {
        return this.texts[id][this.lang];
    }

    setPalette(palette: string) {
        this.palette = palette;        
    }

    setLanguage(lang: string) {
        this.lang = lang;
        this._i18n = "['"+this.lang+"']";
    }

    latexChanged(latex: string) {
        this.latex = latex;
        AlgebraKIT.latex2Html(latex).then(_html => this.latexHtml = _html);
    }

    contentChanged(content: string) {
        this.content = content;
        this.contentHTML = content.replace(/\n/g,'<br>');
        if(this.contentElement) {
            AlgebraKIT.render(this.contentElement.nativeElement);
        }
    }

}